import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustMetrics = [
    {
      id: 'placement',
      icon: 'TrendingUp',
      value: '92%',
      label: 'Placement Rate',
      description: 'Students placed within 6 months'
    },
    {
      id: 'students',
      icon: 'Users',
      value: '2,500+',
      label: 'Students Trained',
      description: 'Successful career transitions'
    },
    {
      id: 'companies',
      icon: 'Building',
      value: '150+',
      label: 'Partner Companies',
      description: 'Hiring our graduates'
    },
    {
      id: 'rating',
      icon: 'Star',
      value: '4.8/5',
      label: 'Student Rating',
      description: 'Based on 1,200+ reviews'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Manvendra Yadav",
      role: "Senior Software Engineer at SimCorp",
      content: "The hands-on training and industry mentorship made all the difference. Highly recommend for career growth.",
      avatar: "/assets/images/Manvendra.jpeg"
    },
    {
      id: 2,
      name: "Aniket Kumar",
      role: "Software Development Engineer at Broki",
      content: "Solvarsity transformed my career. The structured curriculum and placement support helped me land my dream job.",
      avatar: "/assets/images/Aniket.jpeg"
    }
  ];

  const securityBadges = [
    {
      id: 'ssl',
      icon: 'Shield',
      text: 'SSL Secured'
    },
    {
      id: 'payment',
      icon: 'CreditCard',
      text: 'Secure Payment'
    },
    {
      id: 'certified',
      icon: 'Award',
      text: 'ISO Certified'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Trust Metrics */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {trustMetrics.map((metric) => (
          <div key={metric.id} className="text-center p-4 bg-surface border border-border rounded-lg">
            <div className="flex justify-center mb-2">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={metric.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
              </div>
            </div>
            <div className="text-2xl font-bold text-primary mb-1">{metric.value}</div>
            <div className="text-sm font-medium text-foreground mb-1">{metric.label}</div>
            <div className="text-xs text-text-secondary">{metric.description}</div>
          </div>
        ))}
      </div>

      {/* Testimonials */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground text-center">
          What Our Students Say
        </h3>
        <div className="grid md:grid-cols-2 gap-4">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-surface border border-border rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                  // onError={(e) => {
                  //   e.target.src = '/assets/images/no_image.png';
                  // }}
                />
                <div className="flex-1">
                  <div className="flex items-center space-x-1 mb-2">
                    {[...Array(5)].map((_, i) => (
                      <Icon key={i} name="Star" size={14} color="var(--color-warning)" strokeWidth={2}  fill="var(--color-warning)"/>
                    ))}
                  </div>
                  <p className="text-sm text-text-secondary mb-2 leading-relaxed">
                    "{testimonial.content}"
                  </p>
                  <div>
                    <div className="text-sm font-medium text-foreground">{testimonial.name}</div>
                    <div className="text-xs text-text-secondary">{testimonial.role}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Security Badges */}
      <div className="flex justify-center">
        <div className="flex items-center space-x-6 px-6 py-3 bg-muted rounded-lg">
          {securityBadges.map((badge) => (
            <div key={badge.id} className="flex items-center space-x-2">
              <Icon name={badge.icon} size={16} color="var(--color-success)" strokeWidth={2} />
              <span className="text-sm font-medium text-foreground">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;